import { Component, Vue } from "vue-property-decorator";

import { DeviceByWidthEnum } from "@/models/DeviceByWidthEnum";

@Component
export default class DeviceType extends Vue {
  get isMobile(): boolean {
    return this.windowWidth < 576;
  }
  get isTablet(): boolean {
    return this.windowWidth < 768;
  }
  get isMediumScreen(): boolean {
    return this.windowWidth < 992;
  }
  get isUltraWide(): boolean {
    return this.windowWidth >= 2000;
  }
  get getDeviceByWidth(): DeviceByWidthEnum {
    if (this.windowWidth < 576) {
      return DeviceByWidthEnum.Mobile;
    } else if (this.windowWidth < 768) {
      return DeviceByWidthEnum.Tablet;
    } else if (this.windowWidth < 992) {
      return DeviceByWidthEnum.MediumScreen;
    } else if (this.windowWidth < 1200) {
      return DeviceByWidthEnum.HDScreen;
    } else if (this.windowWidth < 2000) {
      return DeviceByWidthEnum.FullHDScreen;
    } else {
      return DeviceByWidthEnum.UltraWide;
    }
  }
}
